import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import {auditEditActions} from "../auditEditSlice";
import {Modal} from "react-bootstrap";
import useAuditEditSelector from "../hooks/useAuditEditSelector";
import createComment from "../factories/createComment";
import Comment from "../../api/types/Comment";

type Props = {
    auditId: string,
    questionId: number
}

export default function CommentAddButton({auditId, questionId}: Props) {
    const predefinedComments = useAuditEditSelector(state => state.questions[questionId]?.predefinedComments || []);
    const dispatch = useDispatch();
    const [modalOpen, setOpenModal] = useState(false);
    const [selected, setSelected] = useState<number[]>([]);
    const {t} = useTranslation();

    const create = () => {
        if (predefinedComments.length) {
            setOpenModal(true);
        } else {
            dispatch(auditEditActions.addComments({auditId, questionId, comments: [createComment()]}))
        }
    }

    const close = () => {
        setOpenModal(false);
        setSelected([]);
    }

    const add = () => {
        const comments: Comment[] = selected.length ?
            predefinedComments.filter((comment, index) => (selected.indexOf(index) !== -1))
                .map(createComment)
            : [createComment()];

        dispatch(auditEditActions.addComments({auditId, questionId, comments}))
        close();
    }

    return (
        <>
            <Modal show={modalOpen} onHide={close}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('Add comment')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {predefinedComments.map((predefinedComment, index) => {
                        const id = "predefined-comment-" + index;

                        return (
                            <div className="form-check mb-2" key={index}>
                                <input type="checkbox" className="form-check-input" id={id}
                                       checked={selected.indexOf(index) !== -1}
                                       onChange={e => e.target.checked ?
                                           setSelected([...selected, index]) :
                                           setSelected(selected.filter(i => i !== index))
                                       }/>
                                <label className="form-check-label" htmlFor={id}>{predefinedComment.comment}</label>
                            </div>
                        )
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-success" onClick={add}>{t('Add comment')}</button>
                </Modal.Footer>
            </Modal>
            <button onClick={create} className="btn btn-link p-0">{t('Add comment')}</button>
        </>
    );
}